/**
 * honu-donation.js — Widget "don additionnel Renatura Congo", multi-currency.
 *
 * Pattern Shopify natif (comme carte-cadeau) : variants fixes EUR, presentation
 * auto-converti selon Shopify.currency.active. Pas de delta math — toujours
 * absolute values lues depuis /cart.js apres mutation.
 *
 * 4 variants fixes : 5 / 10 / 20 / 50 EUR. L option custom ("Autre" qty hack)
 * a ete supprimee 2026-04-19 : Shopify Checkout Extensibility clamp qty=1 sur
 * variants non-taxable+non-shippable.
 *
 * Safeguard : si panier contient uniquement le don (aucun vrai produit),
 * auto-remove le don -> empty state natif Shopify.
 */
(function () {
  'use strict';

  if (window.__honuDonationInit) return;
  window.__honuDonationInit = true;

  var SELECTOR_WIDGET = '[data-honu-donation]';
  var SELECTOR_TOGGLE = '[data-honu-donation-toggle]';
  var SELECTOR_AMT_BTN = '[data-amt]';
  var DONATION_HANDLES = ['don-renatura-congo', 'donation-renatura-congo'];

  var pendingMutation = false;
  var autoRemoveInFlight = false;

  function getWidget(el) {
    return el && el.closest ? el.closest(SELECTOR_WIDGET) : null;
  }

  function isDonationItem(item) {
    return item && DONATION_HANDLES.indexOf(item.handle) !== -1;
  }

  function resolveVariantFor(widget, amount) {
    var fixedMap = {
      5: widget.getAttribute('data-variant-5'),
      10: widget.getAttribute('data-variant-10'),
      20: widget.getAttribute('data-variant-20'),
      50: widget.getAttribute('data-variant-50')
    };
    var fixed = fixedMap[amount];
    if (fixed && fixed !== '0' && fixed !== '') {
      return { variantId: Number(fixed), quantity: 1 };
    }
    return null;
  }

  function fetchJSON(url, body) {
    var opts = { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' } };
    if (body !== undefined) opts.body = JSON.stringify(body);
    return fetch(url, opts).then(function (res) {
      if (!res.ok) {
        return res.text().then(function (t) { throw new Error('HTTP ' + res.status + ' ' + url + ': ' + t.slice(0, 200)); });
      }
      return res.json();
    });
  }

  function notifyCartRefresh() {
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
  }

  // ===== Money formatting (multi-currency via Shopify.currency.active + Intl) =====

  function getActiveCurrency() {
    return (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
  }

  function getActiveLocale() {
    return document.documentElement.lang || 'fr';
  }

  function formatMoneyPresentment(cents) {
    var amount = (Number(cents) || 0) / 100;
    try {
      return new Intl.NumberFormat(getActiveLocale(), {
        style: 'currency',
        currency: getActiveCurrency()
      }).format(amount);
    } catch (e) {
      return amount.toFixed(2) + '\u00a0' + getActiveCurrency();
    }
  }

  // ===== Banner impact = base (server-rendered, items_1%+5% sans don) + donation =====

  function computeImpactFromCart(cart, baseImpactCents) {
    var donationCents = 0;
    for (var i = 0; i < (cart && cart.items ? cart.items.length : 0); i++) {
      if (isDonationItem(cart.items[i])) donationCents += cart.items[i].final_line_price;
    }
    return (baseImpactCents || 0) + donationCents;
  }

  function getBaseImpactCents() {
    var banner = document.querySelector('.honu-impact-banner');
    if (!banner) return 0;
    return parseInt(banner.getAttribute('data-honu-base-impact-cents') || '0', 10);
  }

  // ===== Absolute updaters (iterate all banners + totals: cart page + drawer) =====

  function setImpactAbsolute(impactCents) {
    var banners = document.querySelectorAll('.honu-impact-banner');
    for (var b = 0; b < banners.length; b++) {
      banners[b].setAttribute('data-honu-impact-cents', impactCents);
      var strong = banners[b].querySelector('strong');
      if (strong) strong.textContent = formatMoneyPresentment(impactCents);
    }
  }

  function setTotalAbsolute(totalCents) {
    var totalEls = document.querySelectorAll('[data-honu-cart-total]');
    for (var t = 0; t < totalEls.length; t++) {
      totalEls[t].setAttribute('data-honu-cart-total-cents', totalCents);
      totalEls[t].textContent = formatMoneyPresentment(totalCents);
    }
  }

  // ===== Widget sync depuis /cart.js (source de verite) =====

  function syncWidgetFromCart(widget) {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var donLine = null;
        for (var i = 0; i < cart.items.length; i++) {
          if (isDonationItem(cart.items[i])) { donLine = cart.items[i]; break; }
        }
        if (widget) {
          if (donLine) {
            widget.setAttribute('data-line-key', donLine.key);
            // data-current-amount = valeur EUR du variant (label bouton), pas presentment.
            // Deduit via le mapping variant_id -> amount.
            var amount = 5;
            var variantId = donLine.variant_id;
            if (variantId === Number(widget.getAttribute('data-variant-5'))) amount = 5;
            else if (variantId === Number(widget.getAttribute('data-variant-10'))) amount = 10;
            else if (variantId === Number(widget.getAttribute('data-variant-20'))) amount = 20;
            else if (variantId === Number(widget.getAttribute('data-variant-50'))) amount = 50;
            widget.setAttribute('data-current-amount', amount);
          } else {
            widget.setAttribute('data-line-key', '');
          }
        }
        // Update banner + total ABSOLUS depuis cart data (presentment currency native)
        setImpactAbsolute(computeImpactFromCart(cart, getBaseImpactCents()));
        setTotalAbsolute(cart.total_price);
        return cart;
      })
      .catch(function () { return null; });
  }

  // ===== Cart mutations =====

  function addDonation(widget, amount) {
    var existingKey = widget.getAttribute('data-line-key');
    if (existingKey) return updateDonation(widget, amount);
    if (pendingMutation) return Promise.resolve();
    var resolved = resolveVariantFor(widget, amount);
    if (!resolved) return Promise.resolve();
    pendingMutation = true;
    return fetchJSON('/cart/add.js', { items: [{ id: resolved.variantId, quantity: resolved.quantity }] })
      .then(function () {
        return fetchJSON('/cart/update.js', { attributes: { donation_source: 'widget_v1' } });
      })
      .then(function () { return syncWidgetFromCart(widget); })
      .then(function () {
        notifyCartRefresh();
        if (window.location.pathname.indexOf('/cart') === 0) return refreshCartPageSection();
      })
      .catch(function (err) {
        console.error('[honu-donation] add failed:', err);
        widget.classList.remove('is-active');
        var toggle = widget.querySelector(SELECTOR_TOGGLE);
        if (toggle) toggle.checked = false;
      })
      .finally(function () { pendingMutation = false; });
  }

  function updateDonation(widget, amount) {
    var lineKey = widget.getAttribute('data-line-key');
    if (!lineKey) return addDonation(widget, amount);
    if (pendingMutation) return Promise.resolve();
    var resolved = resolveVariantFor(widget, amount);
    if (!resolved) return Promise.resolve();
    pendingMutation = true;
    widget.setAttribute('data-line-key', '');
    return fetchJSON('/cart/change.js', { id: lineKey, quantity: 0 })
      .then(function () {
        return fetchJSON('/cart/add.js', { items: [{ id: resolved.variantId, quantity: resolved.quantity }] });
      })
      .then(function () { return syncWidgetFromCart(widget); })
      .then(function () {
        // Re-render visibility : la ligne don est native dans cart/drawer, donc il faut
        // re-render la section pour que l affichage (titre variant, prix, image) suive le switch.
        notifyCartRefresh();
        if (window.location.pathname.indexOf('/cart') === 0) refreshCartPageSection();
      })
      .catch(function (err) {
        console.error('[honu-donation] update failed:', err);
        widget.setAttribute('data-line-key', lineKey);
      })
      .finally(function () { pendingMutation = false; });
  }

  // Refresh la section main-cart sur /cart page via Shopify Section Rendering API
  // (pas de full reload). Prestige utilise section_id = section-id attribute de la section.
  function refreshCartPageSection() {
    var section = document.querySelector('.shopify-section--main-cart, [id^="shopify-section-"] .shopify-section--main-cart');
    if (!section) {
      section = document.querySelector('[id^="shopify-section-"]');
      if (!section) return Promise.resolve();
    }
    var container = section.closest('[id^="shopify-section-"]') || section;
    var sectionId = (container.id || '').replace('shopify-section-', '');
    if (!sectionId) return Promise.resolve();
    return fetch('/cart?sections=' + encodeURIComponent(sectionId))
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data && data[sectionId];
        if (!html) return;
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        container.innerHTML = doc.body.innerHTML;
      })
      .catch(function () {});
  }

  function removeDonation(widget) {
    var lineKey = widget.getAttribute('data-line-key');
    if (!lineKey || pendingMutation) return Promise.resolve();
    pendingMutation = true;
    widget.setAttribute('data-line-key', '');
    return fetchJSON('/cart/change.js', { id: lineKey, quantity: 0 })
      .then(function () { return syncWidgetFromCart(widget); })
      .then(function () {
        notifyCartRefresh();
        if (window.location.pathname.indexOf('/cart') === 0) return refreshCartPageSection();
      })
      .catch(function (err) {
        console.error('[honu-donation] remove failed:', err);
        widget.setAttribute('data-line-key', lineKey);
      })
      .finally(function () { pendingMutation = false; });
  }

  // ===== UI handlers =====

  function onToggle(e) {
    if (!e.target.matches || !e.target.matches(SELECTOR_TOGGLE)) return;
    var widget = getWidget(e.target);
    if (!widget) return;
    if (pendingMutation) { e.target.checked = !e.target.checked; return; }
    widget.classList.toggle('is-active', e.target.checked);
    var amount = getSelectedAmount(widget);
    if (e.target.checked) {
      addDonation(widget, amount);
      // Auto-scroll drawer body vers les boutons montant
      setTimeout(function () {
        var amountsEl = widget.querySelector('.honu-donation-widget__amounts');
        if (!amountsEl) return;
        var drawerBody = document.querySelector('cart-drawer')
          && document.querySelector('cart-drawer').shadowRoot
          && document.querySelector('cart-drawer').shadowRoot.querySelector('[part~="body"]');
        if (drawerBody) {
          var rect = amountsEl.getBoundingClientRect();
          var bodyRect = drawerBody.getBoundingClientRect();
          drawerBody.scrollBy({ top: rect.bottom - bodyRect.bottom + 16, behavior: 'smooth' });
        }
      }, 50);
    } else {
      removeDonation(widget);
    }
  }

  function onAmountBtn(e) {
    var btn = e.target.closest ? e.target.closest(SELECTOR_AMT_BTN) : null;
    if (!btn) return;
    var widget = getWidget(btn);
    if (!widget) return;
    e.preventDefault();
    if (pendingMutation) return;
    var newAmount = Number(btn.getAttribute('data-amt'));
    var oldAmount = Number(widget.getAttribute('data-current-amount')) || newAmount;
    if (newAmount === oldAmount && btn.classList.contains('is-selected')) return;

    // UI selection immediate (seul optimistic restant — pas de delta math monnaie)
    var btns = widget.querySelectorAll('.honu-donation-widget__btn');
    for (var i = 0; i < btns.length; i++) btns[i].classList.remove('is-selected');
    btn.classList.add('is-selected');

    var toggle = widget.querySelector(SELECTOR_TOGGLE);
    if (toggle && toggle.checked) {
      updateDonation(widget, newAmount);
    }
  }

  function getSelectedAmount(widget) {
    var selected = widget.querySelector('.honu-donation-widget__btn.is-selected');
    if (selected) return Number(selected.getAttribute('data-amt'));
    return Number(widget.getAttribute('data-current-amount')) || 5;
  }

  // ===== Safeguard panier don-seul -> auto-remove -> empty state natif =====

  function enforceDonationOnlyGuard() {
    if (autoRemoveInFlight || pendingMutation) return;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart || !cart.items || cart.items.length === 0) return;
        var hasReal = false;
        var hasDonation = false;
        var donationLines = [];
        for (var i = 0; i < cart.items.length; i++) {
          if (isDonationItem(cart.items[i])) {
            hasDonation = true;
            donationLines.push(cart.items[i]);
          } else {
            // Gift card OU produit physique = item valide, don conserve.
            // Safeguard trigger UNIQUEMENT sur cart = don seul.
            // Note (2026-04-21 Isa) : gift + don autorise car don reverse 100%
            //   a Renatura (pur don, pas de % Honu applique).
            hasReal = true;
          }
        }
        if (!hasDonation || hasReal) return;
        autoRemoveInFlight = true;
        var ops = donationLines.map(function (it) {
          return fetchJSON('/cart/change.js', { id: it.key, quantity: 0 });
        });
        return Promise.all(ops).then(function () {
          var widgets = document.querySelectorAll(SELECTOR_WIDGET);
          for (var w = 0; w < widgets.length; w++) {
            widgets[w].classList.remove('is-active');
            widgets[w].setAttribute('data-line-key', '');
            var toggle = widgets[w].querySelector(SELECTOR_TOGGLE);
            if (toggle) toggle.checked = false;
          }
          if (window.location.pathname.indexOf('/cart') === 0) {
            window.location.reload();
          } else {
            notifyCartRefresh();
          }
        });
      })
      .catch(function () {})
      .finally(function () { autoRemoveInFlight = false; });
  }

  // cart:change fired by Prestige on native mutations (line-item-quantity +/-).
  // Sur ligne don, Prestige met a jour le cart total global mais PAS la cellule
  // line total (reste sur prix unitaire) ni le drawer line total. Fix : debounced
  // full re-render drawer (cart:refresh) + section cart page.
  var lastCartSig = null;
  function handleCartChangeRefresh() {
    clearTimeout(window.__honuCartChangeTimer);
    window.__honuCartChangeTimer = setTimeout(function () {
      // Re-check au moment du fire (une mutation peut avoir demarre pendant le debounce)
      if (pendingMutation || autoRemoveInFlight) return;
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          if (pendingMutation || autoRemoveInFlight) return;
          var sig = '';
          for (var i = 0; i < cart.items.length; i++) {
            sig += cart.items[i].key + ':' + cart.items[i].quantity + ':' + cart.items[i].final_line_price + '|';
          }
          if (sig === lastCartSig) return;
          lastCartSig = sig;
          notifyCartRefresh();
          if (window.location.pathname.indexOf('/cart') === 0) refreshCartPageSection();
        })
        .catch(function () {});
    }, 300);
  }

  function init() {
    document.addEventListener('change', onToggle, true);
    document.addEventListener('click', onAmountBtn, true);
    // cart:refresh = fire par notre code + drawer Prestige
    // cart:change = fire par Prestige sur mutations natives (line-item-quantity, etc.)
    document.addEventListener('cart:refresh', enforceDonationOnlyGuard);
    document.addEventListener('cart:change', enforceDonationOnlyGuard);
    document.addEventListener('cart:change', handleCartChangeRefresh);
    enforceDonationOnlyGuard();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
